interface HeaderProps {
  title: string;
  subtitle?: string;
  action?: { label: string; onClick: () => void };
}

export const Header: React.FC<HeaderProps> = ({ title, subtitle, action }) => {
  return (
    <div className="flex items-start justify-between mb-6">
      <div className="flex-1">
        <h1
          className="text-2xl font-bold"
          style={{ color: 'var(--text-primary)' }}
        >
          {title}
        </h1>
        {subtitle && (
          <p
            className="text-[15px] mt-1"
            style={{ color: 'var(--text-hint)' }}
          >
            {subtitle}
          </p>
        )}
      </div>
      {action && (
        <button
          onClick={action.onClick}
          className="text-[17px] font-semibold flex-shrink-0 ml-4"
          style={{ color: 'var(--accent)' }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
};
